// extracted by mini-css-extract-plugin
export default {"iconBtnFocusVisible":"styles__iconBtnFocusVisible___tfOv4"};